var $ = jQuery;
// store the slider in a local variable
var flexslider = null;

function getGridSize($slider) {
  return Math.floor($slider.width() / 280);
}

function initFlexslider() {
  var $carSlider = $('#carSlider');
  // Initialize
  var totalCars = $('.car-item-card', $carSlider);
  var gridSize = getGridSize($carSlider);

  flexslider = $carSlider.flexslider({
      animation: 'slide',
      animationLoop: true,
      start: function (slider) {
        $('body').removeClass('loading');
        flexslider = slider;
      },
      minItems: gridSize,
      maxItems: gridSize,
      itemWidth: 262,
      itemMargin: 15,
      controlNav: false,
      prevText: '',
      nextText: ''
  });

  if (gridSize >= totalCars) {
      $carSlider.find('.flex-direction-nav').hide();
  }
}

function initHome(){
  var $carSlider = $('#carSlider');
  var gridSize = getGridSize($carSlider);

  $(window).bind('resizeEnd', function() {
    if(flexslider && $carSlider.length) {
      var gridSize = getGridSize($carSlider);
      flexslider.vars.minItems = gridSize;
      flexslider.vars.maxItems = gridSize;
      if (gridSize >= $carSlider.find('.car-item-card').length) {
        $carSlider.find('.flex-direction-nav').hide();
      } else {
        $carSlider.find('.flex-direction-nav').show();
      }
      flexslider.resize();
    }
  });

  $(window).resize(function() {
    if(this.resizeTO) clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function() {
      $(this).trigger('resizeEnd');
    }, 100);
  });

  $('#partnersSlider').flexslider({
    animation: 'slide',
    minItems: 3,
    maxItems: 6,
    animationLoop: !!1,
    slideshow: !1,
    itemWidth: 169,
    itemMargin: 15,
    controlNav: false,
    prevText: '',
    nextText: ''
  });

  var $simulatorPhone = $('#car_simulator_phone1')
  $simulatorPhone.intlTelInput({
    initialCountry: "auto",
    preferredCountries: ['fr','be','de','en','es','it','ch'],
    nationalMode: true,
    //        numberType: 'FIXED_LINE_OR_MOBILE',
    geoIpLookup: function(callback) {
      var trans = {'en': 'gb'},
      locale=Wlz.Settings.Header.locale
      ;

      callback(trans[locale] ? trans[locale] : locale);
    },
    utilsScript: "/vendor-"+Wlz.Settings.version+"/intl-tel-input/build/js/utils.js" // just for formatting/placeholders etc
  });

  $('#simulator-form').on('submit', function(){
    $simulatorPhone.val($simulatorPhone.intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL));
  });

  $('#top-cars-loader').loader({loadingText: 'Chargement des voitures'});

  if (Wlz.Settings.RecommendedCar.enable){

    var locationSearch = JSON.parse(localStorage.getItem('locationSearch'));
    var locationCar = JSON.parse(localStorage.getItem('locationCar'));
    var location = '';
    var locationSource = '';
    if(locationCar != null && locationSearch != null){
      location = locationCar.dateTime > locationSearch.dateTime ? locationCar.value : locationSearch.value;
      locationSource = locationCar.dateTime > locationSearch.dateTime ? locationSource = 'car' : locationSource = 'search';
    } else if(locationCar != null){
      location = locationCar.value;
      locationSource = 'car';
    } else if(locationSearch != null)  {
      location = locationSearch.value;
      locationSource = 'search';
    }

    var adaptationTypeSearch = JSON.parse(localStorage.getItem('adaptationTypeSearch'));
    var adaptationTypeCar = JSON.parse(localStorage.getItem('adaptationTypeCar'));
    var adaptationType = '';
    if(adaptationTypeSearch != null && adaptationTypeCar != null){
      adaptationType = adaptationTypeCar.dateTime > adaptationTypeSearch.dateTime ? adaptationTypeCar.value : adaptationTypeSearch.value;
    } else if (adaptationTypeCar != null) {
      adaptationType = adaptationTypeCar.value;
    } else if(adaptationTypeSearch != null)  {
      adaptationType = adaptationTypeSearch.value;
    }

    $.ajax({
      url: Wlz.Settings.RecommendedCar.route,
      data: {
        adaptation_type: adaptationType,
        per_page: 8,
        max_old_rental: 4,
        location: location ,
        location_source: locationSource,
        completion_default_cars: true
      },
      success: function (result) {
        var $Slider = $('<ul/>',{
          class: 'slides row'
        }).html(result);
        $('#carSlider').html($Slider);
        initFlexslider();
      }
    });
  } else {
    initFlexslider();
  }
}

initHome();
